// extracted by mini-css-extract-plugin
export var box = "_4c-1";
export var checked = "_4c-2";
export var descriptionSpacer = "_4c-9";
export var disabled = "_4c-3";
export var icon = "_4c-6";
export var input = "_4c-0";
export var labelSpacer = "_4c-8";
export var medium = "_4c-5";
export var small = "_4c-4";
export var text = "_4c-7";